import configureRouter from '../router'
import configureStore from './configure'

const router = configureRouter()
const store = configureStore(router)

export default store
